<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Limites Alocados</span>
        <button class="action-button ml-2 my-1" (click)="goToCreate()">Novo Limite Alocado</button>

    </div>

    <div class="mt-2 alert alert-light" role="alert">
        <div class="row p-3">
            <div class="p-0 mx-3 align-self-center">
                <img src="../../../../../../assets/icons/logo_icon.svg" alt="" height="50px" class="">
            </div>
            <div class="col-11 p-0 m-0 align-self-center">
                <p class="m-0">
                    O limite alocado permite designar um valor para uma conta produto da empresa, dessa forma, quando realizada uma recarga ou utilização do saldo, o valor sairá dessa conta e não da conta corrente. Também é permitido realizar um depósito diretamente no limite alocado, afins de organização de saldos da empresa.
                </p>
            </div>
        </div>
    </div>

    <div class="component-box container-fluid mt-3">
        <div class="container-fluid pt-4">
            <div class="row">
                <div class="col-md-12 text-right">
                    <ul class="options-cadastro">
                        <li>
                            <div *ngIf="false" (click)="deleteFilter()" class="list-select ml-2
                                my-1">
                                <button class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div (click)="true" class="list-select ml-2 my-1">
                                <button class="list-select" type="button">
                                    <span><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar
                                        filtro</span>
                                    <!-- <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span> -->
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="true" class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- <span  class="d-flex justify-content-end clean-modal-text my-2" style="font-size:small;">Data da consulta: {{ queryDate | date: "dd/MM/yyyy HH:mm:ss" }}</span>

            <div class="row m-0 ">
                <div class="col-12">
                    <ul class="options-cadastro pl-0 float-left">
                        <li class="mr-3"><b>Data inicio: </b>{{ filtro.dateStart | date: "dd/MM/yyyy"}}</li>
                        <li class="mr-3"><b>Data fim: </b>{{ filtro.dateEnd | date: "dd/MM/yyyy"}}</li>
                    </ul>
                </div>
            </div>   -->

            <div class="table-overflow">
                <div class="table-responsive visible-table">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <th>#</th>
                            <th>Nome</th>
                            <th>Centro de custo</th>
                            <th>Produto Principal</th>
                            <th colspan="2">Limite alocado</th>
                            <th></th>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor=" let item of allocatedBalances">
                                <td>{{ item.allocatedBalanceId }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.costCenter }}</td>
                                <td>{{ item.principalProduct }}</td>
                                <td class="col-auto">R$</td>
                                <td><span style="float: right; clear: both">{{ (item.balance > 0) ? (item.balance | currency: '' ) : "0,00"}}</span></td>
                                <td>
                                    <div ngbDropdown class="d-inline-block menu-option  d-flex justify-content-end"
                                        placement="left">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                <div ngbDropdownItem (click)="goToEdit(item.allocatedBalanceId)">
                                                    <img src="assets/icons/pencil-purple.png" class="mr-2" />
                                                    Editar
                                                </div>

                                                <div ngbDropdownItem (click)="showTransferModal(modalTransferirSaldo,item)">
                                                    <img src="assets/icons/transfere.png" class="mr-2" style="width: 15px;"/>
                                                    Transferir limite
                                                </div>
                                                
                                                <div *ngIf="item.balance > 0" ngbDropdownItem (click)="showWithdrawModal(modalRetirarSaldo,item)">
                                                    <img src="assets/icons/transfere.png" class="mr-2" style="width: 15px;"/>
                                                    Recuperar limite
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- <div *ngIf="!extrato || extrato == [] || extrato.length == 0" class="text-center">
                        Nenhum registro carregado. Aplique o filtro para carregar a lista
                    </div>

                    <div class="page-custom mt-2">
                        <pagination-controls id="extractReport" (pageChange)="carregarRelatorio($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #modalTransferirSaldo let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Transferência de limites</h5>
            <!-- <p class="clean-modal-subtitle" *ngIf="beneficioValorSelecionado?.valorBeneficio > 0 && qtdBeneficio > 0">
                Qual o valor que gostaria de transferir da conta {{ beneficioValorSelecionado.nomeBeneficio }}?
            </p>
            <p class="clean-modal-subtitle text-center">
                <small>

                </small>
            </p> -->
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="custom-filter-input-container d-flex justify-content-center">
            <mat-form-field class="w-75">
                <mat-label>Digite o valor</mat-label>
                <input [formControl]="value" matInput type="text" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                <!-- <mat-hint align="start">O saldo disponível para transferência é de <strong>{{ beneficioValorSelecionado.valorBeneficio | currency:'BRL':true}}</strong> </mat-hint> -->
            </mat-form-field>

            <!-- <mat-form-field class="w-75">
                    <mat-label>Digite o valor</mat-label>
                    <input [formControl]="nameCtrl" matInput type="text" #valor currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                </mat-form-field> -->
        </div>

        <div class="custom-filter-input-container d-flex justify-content-center">
            <mat-form-field class="w-75">
                <mat-label>Retirada de limite</mat-label>
                <mat-select  [formControl]="allocatedBalanceDebit" id="allocatedeBalances" placeholder="Saldos Alocados">
                    <mat-option [value]="0">
                        Conta Corrente
                    </mat-option>
                    <!-- <ng-container *ngFor="let item of allocatedBalances">
                        <mat-option *ngIf="item.allocatedBalanceId!=selectedAllocatedBalance.allocatedBalanceId"
                            [value]="item.allocatedBalanceId">
                            {{item.name}}
                        </mat-option>
                    </ng-container> -->
                </mat-select>
            </mat-form-field>
        </div>
        <!-- <span class="message-error" *ngIf="mensagemValidacao">
            {{ mensagemValidacao }}
        </span> -->

    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel mr-2" (click)="modal.dismiss('Close click')" ngbAutofocus>
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="transferAllocatedBalance()">
            Transferir
        </button>
    </div>
</ng-template>


<ng-template #modalRetirarSaldo let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Recuperação de limite</h5>
        </div>
    </div>

    <div class="col-12 clean-modal-content">
        <div class="custom-filter-input-container d-flex justify-content-center">
            <mat-form-field class="w-75">
                <mat-label>Digite o valor</mat-label>
                <input [formControl]="value" matInput type="text" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
            </mat-form-field>
        </div>

    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-color-red mr-2" (click)="modal.dismiss('Close click')" ngbAutofocus>
            Cancelar
        </button>
        <button class="custom-modal-button" type="button" (click)="withdrawAllocatedBalance()">
            Recuperar
        </button>
    </div>
</ng-template>